(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headgains-stockists"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hg-stockists')) {
  class HGStockists extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.abort = new AbortController();
      this.on = (el, name, fn, options = {}) => el.addEventListener(name, fn, { ...options, signal: this.abort.signal });
      this.$ = (s) => this.querySelector(s);
      this.messages = JSON.parse(this.$('.hg-messages').textContent);
      this.list = this.$('.hg-list');
      this.map = this.$('.hg-map-viewport');
      this.tileLayer = this.$('.hg-tiles');
      this.markerLayer = this.$('.hg-markers');
      this.status = this.$('.hg-status');
      this.query = this.$('input[name="query"]');
      this.province = this.$('select[name="province"]');
      this.stores = [...this.querySelectorAll('.hg-store')].map((el, index) => ({
        el, index, id: el.dataset.storeId, lat: Number(el.dataset.lat), lng: Number(el.dataset.lng),
        valid: el.dataset.lat.trim() !== '' && el.dataset.lng.trim() !== '' && Number.isFinite(Number(el.dataset.lat)) && Number.isFinite(Number(el.dataset.lng)) && Math.abs(Number(el.dataset.lat)) <= 85 && Math.abs(Number(el.dataset.lng)) <= 180,
        province: el.dataset.province, name: el.dataset.name, location: el.dataset.location,
        search: this.normalize([el.dataset.name,el.dataset.location,el.querySelector('address').textContent,[...this.province.options].find(o=>o.value===el.dataset.province)?.textContent || ''].join(' ')), distance: null
      }));
      this.visible = [...this.stores];
      this.zoom = 3;
      this.center = { lat: 51, lng: -95 };
      this.tiles = new Map();
      this.searchToken = 0;
      this.on(this.$('form'), 'submit', (e) => { e.preventDefault(); this.search(); });
      this.on(this.province, 'change', () => this.search());
      this.on(this.query, 'search', () => { if (!this.query.value) this.search(); });
      this.on(this.$('.hg-reset'), 'click', () => this.reset());
      this.on(this.$('.hg-location'), 'click', () => this.nearMe());
      this.on(this.$('.hg-zoom-in'), 'click', () => this.changeZoom(1));
      this.on(this.$('.hg-zoom-out'), 'click', () => this.changeZoom(-1));
      this.on(this.$('.hg-fit'), 'click', () => this.fit(this.visible));
      this.stores.forEach(store => this.on(store.el.querySelector('.hg-view'), 'click', () => this.select(store, false)));
      this.on(document, 'shopify:block:select', (e) => {
        const s = this.stores.find(x => x.id === e.detail.blockId);
        if (s) { this.reset(); this.select(s, true); }
      });
      this.bindPan();
      this.resize = new ResizeObserver(() => { if (!this.hasSized) { this.hasSized = true; this.fit(this.visible); } else this.draw(); });
      this.resize.observe(this.map);
      this.fit(this.visible);
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); this.pendingFetch?.abort();
      cancelAnimationFrame(this.frame); this.searchToken++; this.ready = false;
    }
    normalize(s) { return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, ''); }
    project(lat, lng, z = this.zoom) {
      const size = 256 * 2 ** z, sin = Math.sin(Math.max(-85, Math.min(85, lat)) * Math.PI / 180);
      return { x: (lng + 180) / 360 * size, y: (0.5 - Math.log((1 + sin) / (1 - sin)) / (4 * Math.PI)) * size };
    }
    unproject(x, y, z = this.zoom) {
      const size = 256 * 2 ** z;
      return { lng: x / size * 360 - 180, lat: Math.atan(Math.sinh(Math.PI * (1 - 2 * y / size))) * 180 / Math.PI };
    }
    fit(stores) {
      const points = stores.filter(s => s.valid);
      if (!points.length) { this.draw(); return; }
      if (points.length === 1) { this.center = { lat: points[0].lat, lng: points[0].lng }; this.zoom = 14; this.draw(); return; }
      const p = points.map(s => this.project(s.lat, s.lng, 0));
      const minX = Math.min(...p.map(q => q.x)), maxX = Math.max(...p.map(q => q.x));
      const minY = Math.min(...p.map(q => q.y)), maxY = Math.max(...p.map(q => q.y));
      const w = Math.max(120, this.map.clientWidth - 110), h = Math.max(120, this.map.clientHeight - 150);
      this.zoom = Math.max(2, Math.min(15, Math.floor(Math.log2(Math.min(w / Math.max(.001, maxX - minX), h / Math.max(.001, maxY - minY))))));
      this.center = this.unproject((minX + maxX) / 2, (minY + maxY) / 2, 0);
      this.draw();
    }
    changeZoom(delta) { this.zoom = Math.max(2, Math.min(17, this.zoom + delta)); this.draw(); }
    draw() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.renderMap());
    }
    renderMap() {
      if (!this.isConnected) return;
      const w = this.map.clientWidth, h = this.map.clientHeight;
      if (!w || !h) return;
      this.center.lat = Math.max(-80, Math.min(80, this.center.lat));
      this.center.lng = Math.max(-180, Math.min(180, this.center.lng));
      const c = this.project(this.center.lat, this.center.lng), left = c.x - w / 2, top = c.y - h / 2;
      const tileCount = 2 ** this.zoom, wanted = new Set();
      const pattern = this.dataset.tiles || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';
      for (let x = Math.floor(left / 256); x <= Math.floor((left + w) / 256); x++) {
        for (let y = Math.floor(top / 256); y <= Math.floor((top + h) / 256); y++) {
          if (y < 0 || y >= tileCount) continue;
          const tx = ((x % tileCount) + tileCount) % tileCount, key = `${this.zoom}/${x}/${y}`;
          wanted.add(key);
          let img = this.tiles.get(key);
          if (!img) {
            img = document.createElement('img'); img.alt = ''; img.draggable = false;
            img.width = 256; img.height = 256; img.referrerPolicy = 'strict-origin-when-cross-origin';
            img.onload = () => { this.$('.hg-map-error').hidden = true; };
            img.onerror = () => { this.$('.hg-map-error').hidden = false; };
            img.src = pattern.replace('{z}', this.zoom).replace('{x}', tx).replace('{y}', y);
            this.tiles.set(key, img); this.tileLayer.append(img);
          }
          img.style.left = `${Math.round(x * 256 - left)}px`; img.style.top = `${Math.round(y * 256 - top)}px`;
        }
      }
      for (const [key, img] of this.tiles) if (!wanted.has(key)) { img.remove(); this.tiles.delete(key); }
      const groups = [];
      for (const s of this.visible.filter(s => s.valid)) {
        const p = this.project(s.lat, s.lng), x = p.x - left, y = p.y - top;
        if (x < -30 || x > w + 30 || y < -30 || y > h + 30) continue;
        let g = groups.find(g => Math.hypot(g.x - x, g.y - y) < 40);
        if (g) g.stores.push(s); else groups.push({ x, y, stores: [s] });
      }
      const fragment = document.createDocumentFragment();
      for (const g of groups) {
        const group = g.stores.length > 1, s = g.stores[0], button = document.createElement('button');
        button.type = 'button'; button.className = `hg-pin${group ? ' is-group' : ''}${g.stores.some(s => s === this.selected) ? ' is-active' : ''}`;
        button.textContent = group ? String(g.stores.length) : String(s.index + 1).padStart(2, '0');
        button.setAttribute('aria-label', group ? `${g.stores.length} ${this.messages.group}` : `${s.name}, ${s.location}`);
        button.style.left = `${g.x}px`; button.style.top = `${g.y}px`;
        button.onclick = () => { if (group) { this.fit(g.stores); } else this.select(s, true); };
        fragment.append(button);
      }
      this.markerLayer.replaceChildren(fragment);
      this.$('.hg-zoom-in').disabled = this.zoom === 17;
      this.$('.hg-zoom-out').disabled = this.zoom === 2;
    }
    bindPan() {
      const pointers = new Map(); let baseline = null;
      const reset = () => {
        const a = [...pointers.values()];
        baseline = a.length ? { x: a.reduce((n,p) => n+p.x,0)/a.length, y: a.reduce((n,p) => n+p.y,0)/a.length, center: this.project(this.center.lat,this.center.lng), zoom: this.zoom, distance: a.length > 1 ? Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y) : 0 } : null;
      };
      this.on(this.map, 'pointerdown', e => {
        if (e.target.closest('button') || (e.pointerType === 'mouse' && e.button !== 0)) return;
        this.map.setPointerCapture(e.pointerId); pointers.set(e.pointerId,{x:e.clientX,y:e.clientY}); reset(); this.map.classList.add('is-dragging');
      });
      this.on(this.map, 'pointermove', e => {
        if (!pointers.has(e.pointerId) || !baseline) return;
        pointers.set(e.pointerId,{x:e.clientX,y:e.clientY}); const a=[...pointers.values()];
        const x=a.reduce((n,p)=>n+p.x,0)/a.length,y=a.reduce((n,p)=>n+p.y,0)/a.length;
        if (a.length>1 && baseline.distance>0) {
          const d=Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y);
          const z=Math.max(2,Math.min(17,baseline.zoom+Math.round(Math.log2(d/baseline.distance))));
          if(z!==this.zoom){this.zoom=z;reset();this.draw();return;}
        }
        this.center=this.unproject(baseline.center.x-(x-baseline.x),baseline.center.y-(y-baseline.y)); this.draw();
      });
      const stop=e=>{pointers.delete(e.pointerId);reset();if(!pointers.size)this.map.classList.remove('is-dragging');};
      this.on(this.map,'pointerup',stop);this.on(this.map,'pointercancel',stop);
      this.on(this.map,'wheel',e=>{if(!e.ctrlKey&&!e.metaKey)return;e.preventDefault();const now=Date.now();if(now-(this.lastWheel||0)>140){this.lastWheel=now;this.changeZoom(e.deltaY<0?1:-1);}},{passive:false});
    }
    select(store, scrollList) {
      this.selected = store;
      this.stores.forEach(s => { s.el.classList.toggle('is-active', s === store); s.el.querySelector('.hg-view').setAttribute('aria-pressed', String(s === store)); });
      if (store.valid) { this.center = { lat: store.lat, lng: store.lng }; this.zoom = 15; }
      const detail = this.$('.hg-map-selection'); detail.hidden = false; detail.textContent = `${store.name} — ${store.location}`;
      if (scrollList) this.list.scrollTop = store.el.offsetTop - this.list.offsetTop;
      this.draw();
    }
    distance(a,b) {
      const r=Math.PI/180,dlat=(b.lat-a.lat)*r,dlng=(b.lng-a.lng)*r;
      const h=Math.sin(dlat/2)**2+Math.cos(a.lat*r)*Math.cos(b.lat*r)*Math.sin(dlng/2)**2;
      return 6371*2*Math.atan2(Math.sqrt(h),Math.sqrt(Math.max(0,1-h)));
    }
    apply(stores, origin = null) {
      this.selected = null; this.$('.hg-map-selection').hidden = true;
      this.visible = [...stores];
      if (origin) this.visible.sort((a,b) => (a.valid ? this.distance(origin,a) : Infinity) - (b.valid ? this.distance(origin,b) : Infinity));
      const set = new Set(stores);
      this.stores.forEach(s => {
        s.el.hidden = !set.has(s); s.el.classList.remove('is-active'); s.el.querySelector('.hg-view').setAttribute('aria-pressed','false');
        const distance = s.el.querySelector('.hg-distance'); distance.hidden = !origin || !s.valid;
        if (origin && s.valid) distance.textContent = `${Math.round(this.distance(origin,s)).toLocaleString()} km ${this.messages.away}`;
      });
      [...this.visible,...this.stores.filter(s=>!set.has(s))].forEach(s => this.list.insertBefore(s.el,this.$('.hg-empty')));
      this.list.scrollTop=0; this.$('.hg-empty').hidden=stores.length>0;
      this.status.textContent=`${stores.length} ${this.messages.locations}${origin ? ' · '+this.messages.nearest : ''}`;
      this.fit(origin ? this.visible.slice(0,3) : this.visible);
    }
    reset() { this.searchToken++; this.pendingFetch?.abort(); this.query.value='';this.province.value='';this.apply(this.stores); }
    search() {
      this.searchToken++;
      const text=this.query.value.trim(), q=this.normalize(text), province=this.province.value;
      const tokens=text.split(/\s+/).map(s=>this.normalize(s)).filter(Boolean);
      const eligible=this.stores.filter(s=>!province||s.province===province);
      const matches=eligible.filter(s=>!q||s.search.includes(q)||tokens.every(t=>s.search.includes(t)));
      this.apply(matches);
    }
    nearMe() {
      const token=++this.searchToken;this.pendingFetch?.abort();
      if(!navigator.geolocation){this.status.textContent=this.messages.denied;return;}
      this.status.textContent=this.messages.finding;
      navigator.geolocation.getCurrentPosition(position=>{
        if(token!==this.searchToken)return;this.query.value='';
        this.apply(this.stores.filter(s=>!this.province.value||s.province===this.province.value),{lat:position.coords.latitude,lng:position.coords.longitude});
      },()=>{if(token===this.searchToken)this.status.textContent=this.messages.denied;},{timeout:10000,maximumAge:60000});
    }
  }
  customElements.define('hg-stockists', HGStockists);
}


  } catch(e) { console.error(e); }
})();
})();
